import H from 'history'
import React from 'react'

import { AppState, ArticlePublication } from '@news-mono/web-common'
import { connect, DispatchProp, useSelector } from 'react-redux'
import { EntitledToView } from '../entitlements/EntitledToView'
import { BreachEvent } from '@news-mono/web-common'
import {
    InlinePositionedContent,
    TargetedContent,
} from '../../templates/Publication/Publication.props'
import { useFeature } from '@news-mono/web-common'
import { TogglesReduxState } from '@news-mono/web-common'
import { createIsEntitledChangeHandler } from './createIsEntitledChangeHandler'
import {
    ResponsiveProps,
    responsiveComponent,
} from '../../__helpers/responsive-component'
import { Block } from '@news-mono/web-common'
import { LazyBreachNotificationWrapper } from './components/BreachNotificationWrapper/BreachNotificationWrapper.lazy'
import { RequiredAccess } from '@news-mono/web-common'
import { useBreachWallConfig } from './components/BreachNotificationWrapper/BreachNotificationWrapper'
import { isLiveSportArticle } from '../../templates/Publication/lib/get-inline-positioned-sports-hub-cta'

interface OwnProps {
    requiredAccess: RequiredAccess
    location: H.Location
    blocks: Block[]
    slug: string
    // inlinePositionedContent and targetedContent are for placing ads between content
    inlinePositionedContent?: InlinePositionedContent[]
    targetedContent?: TargetedContent
    onEvent: (event: BreachEvent) => void
    children: (content: {
        blocks: Block[]
        inlinePositionedContent: InlinePositionedContent[] | undefined
        targetedContent: TargetedContent | undefined
    }) => React.ReactElement<any>
    publication: ArticlePublication
}

export type InternalArticleBreachProps = OwnProps & {
    toggles: TogglesReduxState
} & DispatchProp<any> &
    ResponsiveProps
const mapStateToProps = (state: AppState) => ({ toggles: state.toggles })

export const InternalArticleBreach: React.FC<InternalArticleBreachProps> = (
    props,
) => {
    const {
        blocks,
        inlinePositionedContent,
        targetedContent,
        requiredAccess,
        location,
        onEvent,
        slug,
        publication,
    } = props

    const authState = useSelector((state: AppState) => state.authentication)
    const sportBreachEnabled = useFeature('sport-breach-screen-variant')

    const { creativeName, deal, type } = useBreachWallConfig(location)

    const classification = publication.classification

    const showLiveSportHubTrailer =
        classification &&
        isLiveSportArticle(
            classification,
            publication.primaryTopic,
            publication.secondaryTopics,
        )

    return (
        <EntitledToView
            requiredAccess={requiredAccess}
            articleSlug={slug}
            onIsEntitledChange={createIsEntitledChangeHandler(
                creativeName,
                deal,
                location,
                onEvent,
                authState.isLoggedIn,
                sportBreachEnabled,
            )}
            entitled={() => {
                return props.children({
                    blocks,
                    inlinePositionedContent,
                    targetedContent,
                })
            }}
            notEntitled={() => {
                return (
                    <LazyBreachNotificationWrapper
                        breachDeal={deal}
                        articleId={publication.id}
                        breachCreativeName={creativeName}
                        onEvent={props.onEvent}
                        type={type}
                        contentOptions={{ showLiveSportHubTrailer }}
                    />
                )
            }}
        />
    )
}

export const ArticleBreach: React.ComponentType<OwnProps> = responsiveComponent<
    OwnProps
>(
    connect<{ toggles: TogglesReduxState }, {}, OwnProps, AppState>(
        mapStateToProps,
        null,
        null,
        {},
    )(InternalArticleBreach),
)

ArticleBreach.displayName = 'ArticleBreach'
